const BASE_URL = '/'
const AUTH = `${BASE_URL}auth`
const HOME = `${BASE_URL}home`
const PERIODS = `${BASE_URL}periods/:periodId`
const SELECT_CLIENTS = `${PERIODS}/select-clients`
const SEND_WHATSAPP = `${PERIODS}/whatsapp`
const PERIODS_DETAIL = `${BASE_URL}periods/detail`
const UNAUTHORIZED = `${BASE_URL}not-authorized`

export default {
  BASE_URL,
  AUTH,
  HOME,
  PERIODS,
  PERIODS_DETAIL,
  UNAUTHORIZED,
  SELECT_CLIENTS,
  SEND_WHATSAPP,
}
